<template>
    <div class="content">
        <div class="content-select">
            <el-row :gutter="20">
                <el-col :span="4">
                    <div class="select-title">
                        <div class="title-img">
                            <img src="@/assets/appraisal/select-icon.png" alt="">
                        </div>
                        <div class="title-info">
                            <span>复议诉讼</span>
                        </div>
                    </div>
                </el-col>
            </el-row>
        </div>
       <div class="content-header">
        <myTableSearch :isOperate="true" :operateWidth="350" :formData="formData" :tableLabel="tableLabel"
				:queryFn="queryFn" :queryParams="queryParams" @successQuery="successQuery" :searchColLg="6" ref="tableRef" dataRow="rows">
				<template slot="policyLabelList" slot-scope="scope">
					<span v-if="scope.row.policyLabelList && scope.row.policyLabelList.length > 0">
						<span v-for="(item, index) in scope.row.policyLabelList" :key="index">
							{{ item.labelName || item }}
							<span v-if="index < scope.row.policyLabelList.length - 1">、</span>
						</span>
					</span>
					<span v-else>-</span>
				</template>
				<template slot="link" slot-scope="scope">
					<a v-if="scope.row.link" :href="scope.row.link" target="_blank" class="link-text">{{ scope.row.link }}</a>
					<span v-else>-</span>
				</template>
				<template slot="publishStatus" slot-scope="scope">
					<span :style="{ 
						display: 'inline-flex', 
						alignItems: 'center', 
						justifyContent: 'center',
						minWidth: '60px',
						height: '24px',
						padding: '0 12px',
						borderRadius: '4px',
						fontSize: '12px',
						color: '#fff',
						backgroundColor: scope.row.publishStatus == '1' ? '#20C980' : '#FF3E50'
					}">
						{{ scope.row.publishStatus == '1' ? '已发布' : '未发布' }}
					</span>
				</template>
				<template slot="tool">
					<div class="toolbar-container">
						<div class="toolbar-left">
							<div class="tool-btn" @click="handleRefresh" title="刷新">
								<img :src="refreshIcon" alt="刷新" class="toolbar-icon">
							</div>
						</div>
						<div class="toolbar-right">
							<el-button type="primary" icon="el-icon-fake custom-icon icon-policy" @click="handleAddAppointment">添加政策</el-button>
							<el-button plain type="info" icon="el-icon-fake custom-icon icon-policy-download" :loading="downloadTemplateLoading" @click="handleDownloadTemplate">下载模版</el-button>
							<el-upload
								ref="uploadRef"
								action="#"
								:auto-upload="false"
								:show-file-list="false"
								:on-change="handleImportFile"
								accept=".xls,.xlsx"
								class="import-upload"
							>
								<el-button plain type="info" icon="el-icon-fake custom-icon icon-policy-insert" :loading="importLoading">导入</el-button>
							</el-upload>
						</div>
					</div>
				</template>
				<template slot="operate" slot-scope="scope">
					<el-button @click="handleView(scope.row)" size="small" type="text">查看</el-button>
					<el-button v-if="scope.row.publishStatus != '1'" @click="handleEdit(scope.row)" size="small" type="text">编辑</el-button>
					<el-button 
						v-if="scope.row.publishStatus == '0'" 
						@click="handlePublish(scope.row)" 
						size="small" 
						type="text"
						style="color: #409EFF;"
					>发布</el-button>
					<el-button 
						v-if="scope.row.publishStatus == '1'" 
						@click="handleUnpublish(scope.row)" 
						size="small" 
						type="text"
						style="color: #E6A23C;"
					>下架</el-button>
					<el-button 
						v-if="scope.row.publishStatus != '1'"
						type="text" 
						style="color:rgb(241, 74, 63);" 
						size="small"
						@click="handleDel(scope.row)"
					>删除</el-button>
				</template>
			</myTableSearch>
            <!-- 新增/编辑/查看政策 -->
		<policyDialog v-if="isSubscribeDialog" :isDialog="isSubscribeDialog" :isEdit="isEdit" :isView="isView" :editData="editData"
			@handleClose="isSubscribeDialog = false" @success="handleRefresh">
		</policyDialog>
        <!-- 导入结果 -->
		<importResultDialog v-if="isImportResultDialog" :isDialog="isImportResultDialog" :resultData="importResultData"
			@handleClose="isImportResultDialog = false">
		</importResultDialog>
       </div>
    </div>
</template>

<script>
import '@/assets/css/base.css'
import {downloadPolicyTemplate, importPolicy, getPolicyList, deletePolicy, publishPolicy, unpublishPolicy} from '@/api/policy/management'
import { getListByDictType } from '@/api/sys/dictData'
import policyDialog from './components/policyDialog.vue'
import importResultDialog from './components/importResultDialog.vue'
import refreshIcon from '@/assets/pages/appointment/refresh.png'

export default {
    name: 'PolicyList',
    components: {
		policyDialog,
        importResultDialog
	},
    data() {
        return {
			refreshIcon,
			currentPage: 1,
			downloadTemplateLoading: false,
			importLoading: false,
			queryParams: {
				pageNum: 1,
				pageSize: 10,
				pageSizes: [10, 20, 50]
			},
			isSubscribeDialog: false,//新增/编辑/查看政策弹窗
			isEdit: false,//是否为编辑模式
			isView: false,//是否为查看模式
			editData: {},//编辑/查看时的数据
			isImportResultDialog: false,//导入结果弹窗
			importResultData: '',//导入结果
			formData: [
				{
					label: '政策标签',
					type: 'select',
					key: 'labelCode',
					colLg: 6,
					data: []
				},
				{
					label: '文件名称',
					type: 'input',
					key: 'fileName',
					colLg: 6,
					placeholder: '文件名称'
				},
				{
					label: '文号',
					type: 'input',
					key: 'referenceNumber',
					colLg: 6,
					placeholder: '文号'
				}
			],
			tableLabel: [
				{
					prop: 'policyLabelList',
					label: '政策标签',
					minWidth: 150
				},
				{
					prop: 'fileName',
					label: '文件名称',
					minWidth: 300
				},
				{
					prop: 'referenceNumber',
					label: '文号',
					width: 200
				},
				{
					prop: 'link',
					label: '链接',
					minWidth: 200
				},
				{
					prop: 'publishStatus',
					label: '状态',
					width: 100
				}
			],
		}
    },
    mounted() {
        this.loadPolicyTagData()
    },
    methods: {
		// 获取列表数据
		queryFn(queryParams) {
			return getPolicyList(queryParams)
		},
		// 获取政策标签字典
		async loadPolicyTagData() {
			const res = await getListByDictType('policy_info_label')
			if (res && res.code === 200 && res.data) {
				this.updateFormDataWithPolicyTag(res.data)
			}
		},
		// 更新政策标签下拉选项
		updateFormDataWithPolicyTag(tagData) {
			if (!tagData) return

			const tagIndex = this.formData.findIndex(item => item.key === 'labelCode')
			if (tagIndex !== -1) {
				// 在数据开头添加"全部"选项
				const dataWithAll = [
					{
						dictLabel: '全部',
						dictValue: ''
					},
					...tagData
				]
				this.$set(this.formData[tagIndex], 'data', dataWithAll)
			}
		},
		// 上一页
		handlePrevPage() {
			if (this.currentPage > 1) {
				this.currentPage--;
				this.queryParams.pageNum = this.currentPage;
				this.$refs.tableRef && this.$refs.tableRef.handleSearch();
			}
		},
		// 下一页
		handleNextPage() {
			this.currentPage++;
			this.queryParams.pageNum = this.currentPage;
			this.$refs.tableRef && this.$refs.tableRef.handleSearch();
		},
		// 刷新列表
		handleRefresh() {
			this.queryParams.pageNum = 1;
			this.currentPage = 1;
			this.$refs.tableRef && this.$refs.tableRef.handleSearch();
		},
		// 删除
		handleBatchDelete() {
			this.$refs.tableRef && this.$refs.tableRef.deleteAll();
		},
		// 下载导入模板
		handleDownloadTemplate() {
			this.downloadTemplateLoading = true
			downloadPolicyTemplate().then(res => {
				if (res) {
					this.downloadBlobFile(res, '政策导入模板.xls');
				}
			}).finally(() => {
				this.downloadTemplateLoading = false
			})
		},
		// 导入文件
		handleImportFile(file) {
			const isExcel = file.raw.type === 'application/vnd.ms-excel' || 
				file.raw.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
			const isLt10M = file.raw.size / 1024 / 1024 < 10

			if (!isExcel) {
				this.$message.error('只能上传 .xls 或 .xlsx 格式的文件！')
				return
			}
			if (!isLt10M) {
				this.$message.error('文件大小不能超过 10MB！')
				return
			}

			this.importLoading = true
			const formData = new FormData()
			formData.append('file', file.raw)

			importPolicy(formData).then(res => {
				if (res && res.code === 200) {
					this.importResultData = res.data
					this.isImportResultDialog = true
					this.handleRefresh()
				} else {
					this.$message.error(res.msg || '导入失败')
				}
			}).catch(err => {
				console.error('导入出错', err)
				this.$message.error('导入失败')
			}).finally(() => {
				this.importLoading = false
				this.$refs.uploadRef && this.$refs.uploadRef.clearFiles()
			})
		},
		// 新增政策
		handleAddAppointment() {
			this.isEdit = false
			this.isView = false
			this.editData = {}
			this.isSubscribeDialog = true
		},
		// 查看政策
		handleView(row) {
			this.isEdit = false
			this.isView = true
			this.editData = { ...row }
			this.isSubscribeDialog = true
		},
		// 编辑政策
		handleEdit(row) {
			this.isEdit = true
			this.isView = false
			this.editData = { ...row }
			this.isSubscribeDialog = true
		},
		// 发布政策
		handlePublish(row) {
			this.$confirm('确定要发布该政策吗？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				publishPolicy({id: row.id}).then(res => {
					if (res && res.code === 200) {
						this.$message.success('发布成功')
						this.handleRefresh()
					} else {
						this.$message.error(res.msg || '发布失败')
					}
				}).catch(err => {
					console.error('发布失败', err)
					this.$message.error('发布失败')
				})
			}).catch(() => {})
		},
		// 下架政策
		handleUnpublish(row) {
			this.$confirm('确定要下架该政策吗？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				unpublishPolicy({id: row.id}).then(res => {
					if (res && res.code === 200) {
						this.$message.success('下架成功')
						this.handleRefresh()
					} else {
						this.$message.error(res.msg || '下架失败')
					}
				}).catch(err => {
					console.error('下架失败', err)
					this.$message.error('下架失败')
				})
			}).catch(() => {})
		},
		// 删除政策
		handleDel(row) {
			this.$confirm('确定要删除该政策吗？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				deletePolicy({id: row.id}).then(res => {
					if (res && res.code === 200) {
						this.$message.success('删除成功')
						this.handleRefresh()
					} else {
						this.$message.error(res.msg || '删除失败')
					}
				}).catch(err => {
					console.error('删除失败', err)
					this.$message.error('删除失败')
				})
			}).catch(() => {})
		},
		// 更新总数
		successQuery(e) {
			this.syrkNum = e.total;
		},
	},
}
</script>

<style lang="scss" scoped>
.content {
    width: 100%;
    height: 100%;
    background: #fff;
    display: flex;
    flex-direction: column;

    &-select{
        height: 50px;
        .select-title{
            height: 46px;
            background: url('~@/assets/appraisal/selectBg.png') no-repeat;
            background-size: 100% 100%;
            display: flex;
            align-items: center;
            gap: 12px;
            padding-left: 16px;
            .title-img{
                width: 18px;
                height: 18px;
                img{
                    width: 100%;
                    height: 100%;
                }
            }
            .title-info{
                color: var(--vt-c-black-mute-soft);
                font-size: 16px;
                font-weight: 700;
            }
        }
        .select-serch{
            margin-top: 12px;
            display: flex;
            align-items: center;
            gap: 8px;
            .serch-hint{
                color: var(--vt-c-black-mute-soft);
                font-size: 14px;
                font-weight: 400;
            }
            .serch-info{
                height: 28px;
                display: flex;
                align-items: center;
                gap: 12px;
                .info-item{
                    width: 120px;
                    height: 28px;
                    text-align: center;
                    line-height: 28px;
                    background: var(--vt-c-blue-mute);
                    color: var(--vt-c-blue);
                    border-radius: 2px;
                    cursor: pointer;
                    transition: all 0.3s ease;
                    
                    &:hover {
                        opacity: 0.8;
                    }
                    
                    &.active {
                        background: var(--vt-c-blue);
                        color: var(--vt-c-white);
                    }
                    
                    &:active:not(.active) {
                        transform: scale(0.98);
                    }
                }
            }
        }
    }
    &-header{
        margin-top: 16px;
        padding: 0 24px;
        
        /deep/.myTableSearch {
            padding: 0;
        }
    }
}

.link-text {
    color: #409eff;
    text-decoration: none;
    cursor: pointer;
    
    &:hover {
        text-decoration: underline;
    }
}

.toolbar-container {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 0;

    .toolbar-icon {
        width: 24px;
        height: 24px;
    }

    .add-icon {
        width: 20px;
        height: 20px;
        margin-right: 6px;
    }

    .toolbar-left {
        display: flex;
        align-items: center;
        gap: 12px;
		.tool-btn {
			width: 36px;
			height: 36px;
			display: flex;
			align-items: center;
			justify-content: center;
			border: 1px solid #dcdfe6;
			cursor: pointer;
			transition: all 0.2s;
			background-color: #FCFCFCFF;
		}
        .list-title {
            font-size: 14px;
            font-weight: 400;
            color:var(--vt-c-blue-soft);
        }
    }

    .toolbar-right {
        display: flex;
        align-items: center;
        gap: 12px;

        .import-upload {
            display: inline-block;
            
            /deep/.el-upload {
                display: inline-block;
            }
        }

        .el-button {
            height: 36px;
            padding: 0 16px;
        }
    }
}
</style>